<template>
  <div class="buff-bar" v-if="buffs.length > 0">
    <el-tooltip v-for="b in buffs" :key="b.key" placement="bottom"
                :content="tooltipOf(b)" effect="dark">
      <div class="buff-icon" :class="{ 'buff-ending': b.remainSeconds <= 600 }">
        <span class="buff-name">{{ b.name }}</span>
        <span class="buff-countdown">{{ countdownOf(b.remainSeconds) }}</span>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import {getRequest} from '../../utils/api'

// buff key → 效果文案模板（rate 为千分比）
const EFFECT_TEXT = {
  meal_produce: rate => '劳作双倍几率+' + (rate / 10) + '%（采集/种植/钓鱼/挖矿）',
  meal_mastery: rate => '制造/烹饪熟练度双倍几率+' + (rate / 10) + '%',
  meal_rare: rate => '钓鱼/挖矿稀有收获（次稀有）几率+' + (rate / 10) + '%'
}

export default {
  name: 'BuffBar',
  data: function () {
    return {
      buffs: [],
      timer: null,
      ticker: null
    }
  },
  mounted: function () {
    this.loadBuffs()
    // 30 秒与服务端校准一次；本地每秒自减倒计时
    this.timer = setInterval(this.loadBuffs, 30000)
    this.ticker = setInterval(this.tickDown, 1000)
    // 食用/结算等场景触发立即刷新
    this.$root.eventHub.$on('buffRefresh', this.loadBuffs)
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
    clearInterval(this.ticker)
    this.$root.eventHub.$off('buffRefresh', this.loadBuffs)
  },
  methods: {
    loadBuffs: function () {
      getRequest('/item/item/buff/list').then(resp => {
        if (resp && resp.data && resp.data.data) {
          this.buffs = resp.data.data.filter(b => b.remainSeconds > 0)
        } else {
          this.buffs = []
        }
      }).catch(() => {})
    },
    tickDown: function () {
      let expired = false
      this.buffs.forEach(b => {
        if (b.remainSeconds > 0) {
          b.remainSeconds -= 1
          if (b.remainSeconds <= 0) expired = true
        }
      })
      if (expired) {
        this.$message.info('有增益已过期，可再吃一份增益料理续上')
        this.loadBuffs()
      }
    },
    countdownOf: function (seconds) {
      if (seconds >= 3600) {
        return Math.floor(seconds / 60) + '分'
      }
      let m = Math.floor(seconds / 60)
      let s = seconds % 60
      return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s)
    },
    tooltipOf: function (b) {
      let effect = EFFECT_TEXT[b.key] ? EFFECT_TEXT[b.key](b.rate || 0) : ''
      let src = b.sourceName ? '｜来源：' + b.sourceName : ''
      let remain = '｜剩余 ' + this.countdownOf(b.remainSeconds)
      return b.name + '：' + effect + src + remain
    }
  }
}
</script>

<style scoped>
.buff-bar {
  display: flex;
  gap: 4px;
  margin: 2px 0;
}

.buff-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1px 5px;
  border: 1px solid #bce8a3;
  border-radius: 4px;
  background: #f3faee;
  cursor: default;
  line-height: 1.3;
}

.buff-name {
  font-size: 12px;
  color: #4a7c2e;
}

.buff-countdown {
  font-size: 11px;
  color: #7ba05b;
}

.buff-ending {
  border-color: #f0a9a0;
  background: #fdf1ef;
}

.buff-ending .buff-name {
  color: #c0392b;
}

.buff-ending .buff-countdown {
  color: #e74c3c;
}
</style>
